import { Controller } from '@hotwired/stimulus';
import { numberToHumanSize } from 'manage/utils/numberToHumanSize';

export default class extends Controller {
  static values = {
    max: {
      type: Number,
      default: 10 * 1024 * 1024, // とりあえず10MB
    },
  };

  // action="change->file-field-validator#validate"
  validate({ target }) {
    const errors = [];

    for (const file of target.files) {
      if (file.size > this.maxValue) {
        errors.push(
          `【エラー】ファイルサイズが大きすぎます(${numberToHumanSize(this.maxValue)}まで)`,
        );
      }
    }

    if (errors.length > 0) {
      alertify.error(errors.join('<br>'));
      target.value = '';
    }
  }
}
